import React from 'react'
import { useTrans } from 'hooks'
import { WContainer, ImageBox, Button } from 'react-components/atoms'

const CheckoutErrorTemplate = props => {
  const { className = '' } = props

  const t = useTrans()

  return (
    <div className={`checkout-error-template ${className ? ` ${className}` : ''}`}>
      <WContainer>
        <div className="checkout-error-template__card">
          <ImageBox
            src="/images/ecommerce/thankyou.png"
            maxWidth={409}
            maxHeight={238}
            classPrefix="checkout-error-template"
          />
          <h1 className="checkout-error-template__title">{t('Errore')}</h1>
          <p
            className="checkout-error-template__description"
            dangerouslySetInnerHTML={{
              __html: t("Si è verificato un errore nell'elaborazione del tuo ordine"),
            }}
          />
          <Button label={t('Torna al carrello')} href="/cart" />
        </div>
      </WContainer>
    </div>
  )
}

export default CheckoutErrorTemplate
